<template>
  <div class="suggestion">
    <div class="group">
      <label>{{ $t('cross_sell.suggested_item') }}</label>
      <AjaxSelect
          v-model="suggestionItem"
          :api="`/api/entity/item/select`"
          :map-fn="(i) => i.name"
          :allow-empty-search="true"
          :query="{inventory: inventoryId}"
          :placeholder="$t('search')"
          :ignored="ignoredItem"
      />
    </div>
    <div class="group">
      <LocalizedInput :title="$t('cross_sell.justification')" :translate="suggestionText" :max-size="100" :validate="validate" :errorsKey="'item.crossSells[' + index + '].text.->'"/>
    </div>
    <div class="suggestion__close" @click="remove">
      <svgicon src="icon/close.svg" class="icon" width="16" height="16"></svgicon>
    </div>
  </div>
</template>

<script>
import LocalizedInput from "@/components/tools/LocalizedInput.vue";
import AjaxSelect from "@/components/tools/AjaxSelect";
export default {
  name: "CrossSellSuggestion",

  components: { LocalizedInput, AjaxSelect },

  props: {
    suggestion: Object,
    ignoredItem: Array,
    initialNameCache: Map,
    validate: Object,
    index: Number
  },

  data() {
    return {
      suggestionItem: {
        id: this.suggestion.item,
        name: this.suggestion.item ? (this.initialNameCache.get(this.suggestion.item) || null) : null
      },
      suggestionText: this.suggestion.text && this.suggestion.text['->'] ? this.suggestion.text['->'] : {}
    }
  },

  watch: {
    suggestionItem: {
      handler(newItem) {
        if (newItem) {
          this.$emit("setSuggestionItem", newItem.id);
        }
      },
      deep: true
    },
    suggestionText: {
      handler(newText) {
        this.$emit("setSuggestionText", newText);
      },
      deep: true
    }
  },

  computed: {
    company() {
      return this.$store.state.contextCompany;
    },
    inventoryId() {
      return this.company ? this.company.inventory.id : null;
    }
  },

  methods: {
    remove() {
      this.$emit("remove");
    }
  }
}
</script>

<style lang="scss" scoped>
  .suggestion {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    position: relative;
    height: 220px;
    padding: 20px 40px 20px 20px;
    border-radius: 12px;
    background-color: #fafafa;
    margin: 20px 20px 0 20px;
    flex-basis: calc(50% - 40px);

    .group {
      flex-grow: 1;
    }
  }

  .suggestion__close {
    position: absolute;
    top: 12px;
    right: 12px;
    fill: var(--primary-color);
    cursor: pointer;
  }

</style>